<template>
  <div>
    <div>
      <div class="search-wrap">
        <el-form inline>
          <el-form-item>
            <el-button size="mini" @click="search">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" @click="download">导出模板</el-button>
          </el-form-item>
          <el-form-item>
            <el-upload method="post" :action="upload_url" :on-success="upload" :before-upload="beforeUpload">
              <el-button size="mini" type="primary">导入数据</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div>
      <el-table border :data="table_list">
        <el-table-column label="项目名称" prop="project_name"></el-table-column>
        <el-table-column label="能耗类型" prop="energy_type"></el-table-column>
        <el-table-column label="每月抄表日期" prop="read_day"></el-table-column>
      </el-table>
    </div>

    <div class="mt-10" v-if="is_uploaded">
      <div>上传结果</div>
      <el-table border :data="upload_result">
        <el-table-column label="数据" prop="name"></el-table-column>
        <el-table-column label="结果" prop="result"></el-table-column>
        <el-table-column label="错误信息" prop="msg"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import CommonMixin from "../../common/CommonMixin";
import MeterHttp from "../../common/MeterHttp";
export default {
  inject:['mainObj','componentId','setComponentId'],
  mixins:[CommonMixin],
  mounted() {
    this.upload_url = MeterHttp.getBaseURL() + 'MeterPlan/uploadData'
  },
  data() {
    return {
      table_list : [],
      is_uploaded : false ,
      upload_result : [],
      upload_url : ''
    };
  },
  methods : {
    checkProject(){
      if(this.mainObj.project_id <= 0){
        this.$message({type: 'error', message: '请在左边导航的选择项目'})
        return false;
      }
      return true;
    },
    search(){
      if(this.checkProject()){
        let project_name = this.mainObj.project_name;
        MeterHttp.get('MeterPlan/getPlan' , {project_id : this.mainObj.project_id} , res => {
          if(res.code){
            this.table_list = [{
              project_name : res.data.project_name ,
              energy_type : res.data.energy === 1 ? '分摊制' : '包干制',
              read_day : res.data.read_day
            }]
          }else{
            this.$message({type: 'error', message: res.msg})
          }
        })
      }
    },
    download(){
      // 下载模板
      let that = this;
      MeterHttp.get('MeterPlan/exportDemo',{},function(res){
        if(res.code){
          let url = res.data;
          // 文件名
          let fileArr = url.split('/');
          let filename = fileArr[fileArr.length - 1];
          // a 标签打卡下载地址下载文件
          let a = document.createElement('a');
          a.target = '_blank';
          a.href = url;
          a.download = filename;
          a.click();
        }else{
          that.$message({type : 'error' , message : '下载失败'});
        }
      })
    },
    beforeUpload(){
      this.upload_result = [];
      this.is_uploaded = false;
    },
    upload(res){
      if(res.code){
        this.is_uploaded = true;
        this.upload_result = res.data;
      }else{
        this.$message({type : 'error' , message : res.msg})
      }
    },
  },
  watch : {
    
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_plan/MeterBudget.vue